const PRODUCTS = [
    { name: 'hosting-web', id: 5 },
    { name: 'hosting-mail', id: 4 },
    { name: 'domain', id: 3 }
];

export class UserState {
    products: { name: string; id: number }[] = PRODUCTS;
}
